import {
  Dialog,
  DialogCloseX,
  DialogButton,
  DialogButtons,
  DialogContent,
  DialogHeading,
  DialogTrigger,
  PopoverMenuItem,
  PopoverMenuItemIcon,
  TrashCanOutlineIcon,
  usePopoverContext,
  useToasterContext,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"
import { useEntryModalPrivateContext } from "../EntryModalPrivateContext"
import styles from "./ContextMenu.module.scss"
import {
  useOverlayLoader,
  usePolyglot,
} from "src/contexts"
import {
  DeleteEntryErrorToast,
  DeleteEntrySuccessToast,
} from "src/toasts"

const polyglotPrefix = "components.entry_modal.entry_context_menu."

export function DeleteEntry() {
  const polyglot = usePolyglot()
  const { destroyEntry } = useEntryModalPrivateContext()
  const { setOpen: setPopoverOpen } = usePopoverContext()
  const { showToast } = useToasterContext()
  const { setIsOverlayLoaderVisible } = useOverlayLoader()

  const deleteAndClose = useCallback(
    () => {
      void (async () => {
        setIsOverlayLoaderVisible(true)

        try {
          await destroyEntry()

          showToast(
            "delete-entry-success-toast",
            DeleteEntrySuccessToast,
          )
        } catch {
          showToast(
            "delete-entry-error-toast",
            DeleteEntryErrorToast,
          )
        }

        setPopoverOpen(false)
        setIsOverlayLoaderVisible(false)
      })()
    },
    [
      destroyEntry,
      setPopoverOpen,
      showToast,
      setIsOverlayLoaderVisible,
    ],
  )

  return (
    <Dialog>
      <DialogTrigger asChild>
        <PopoverMenuItem
          className={styles.deleteButton}
          id="delete-button"
        >
          <PopoverMenuItemIcon >
            <TrashCanOutlineIcon />
          </PopoverMenuItemIcon>
          {polyglot.t(`${polyglotPrefix}delete_cta`)}
        </PopoverMenuItem>
      </DialogTrigger>
      <DialogContent>
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}delete_dialog_header`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogButtons>
          <DialogButton
            stylePreset="destructive"
            onClick={deleteAndClose}
            id="confirm-delete"
          >
            {polyglot.t(`${polyglotPrefix}delete_dialog_confirm`)}
          </DialogButton>
          <DialogButton>
            {polyglot.t(`${polyglotPrefix}delete_dialog_cancel`)}
          </DialogButton>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}
